module.exports = __webpack_public_path__ + "img/Vector.2025f997.svg";